import {trackPromise} from "react-promise-tracker";
import Call from "../../service/axiosV2";
import {getUrl} from "../../constants/urls";

export const getCompatibleControllersAsync = (locations, mac) => {
  const url = getUrl("compatibleControllers");
  return trackPromise(Call.get(url, {params: {source_mac: mac, location_id: locations}}));
};

export const cloneProfileAsync = (sourceMac, targetMac) => {
  const url = getUrl("cloneProfile")(targetMac);
  return trackPromise(Call.post(url, {source_mac: sourceMac}));
};

export const cloneSensorsStatusAsync = (targetMac, taskId) => {
  const url = getUrl("cloneSensorsStatus")(targetMac);
  return Call.get(url, {params: {task_id: taskId}});
};
